const _parametersSelector = state => state.app.parameters

export const parametersSelector = state => _parametersSelector(state).value
export const parametersLoadingSelector = state => _parametersSelector(state).loading
export const parametersErrorSelector = state => _parametersSelector(state).error
